import { ExamineeContactInfo } from "../../../store/newExamineeSlice";
import { StartAssessmentStepNames } from "../../../store/startAssessmentSlice";
import { ChooseAssessmentForm } from "./steps/ChooseAssessmentForm";
import { Checklist } from "./steps/Checklist";

export const StartAssessmentBody = ({
    currentStep,
    examinee,
    locationId,
    upcomingAssessmentId
}: StartAssessmentBodyProps): JSX.Element => {
    return (
        <>
            <p className="has-text-centered has-text-weight-bold is-size-3">{`${examinee.firstName} ${examinee.lastName}`}</p>
            <div className="is-flex">
                {currentStep === StartAssessmentStepNames.AssessmentForm && (
                    <ChooseAssessmentForm
                        examinee={examinee}
                        locationId={locationId}
                        upcomingAssessmentId={upcomingAssessmentId}
                    />
                )}
                {currentStep === StartAssessmentStepNames.Checklist && <Checklist />}
            </div>
        </>
    );
};

interface StartAssessmentBodyProps {
    currentStep: StartAssessmentStepNames;
    examinee: ExamineeContactInfo;
    locationId: number;
    upcomingAssessmentId?: number;
}
